import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { APPLICATION_ROUTES } from './app.routes';
import { AuthInterceptor } from './core/authentication/auth.interceptor';

import { HttpClient } from '@angular/common/http';
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { AuthService } from './core/services/auth.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function initializeAuthentication() {
  localStorage.removeItem('appToken');
  return inject(AuthService).initializeSession();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      return initializeAuthentication();
    }),
    provideRouter(APPLICATION_ROUTES, withComponentInputBinding()),
    provideFirebaseApp(() =>
      initializeApp({
        apiKey: environment.firebase.apiKey,
        authDomain: environment.firebase.authDomain,
        projectId: environment.firebase.projectId,
      }),
    ),
    provideAuth(() => getAuth()),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    MatSnackBarModule,
    MatToolbarModule,
    MatIconModule,
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'it',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
